import unifiIconSvg from "./assets/unifi-icon.svg";

export default {
  logo: unifiIconSvg,
  title: "UniFi Network Server",
  description: "Thanks for Downloading! ",
  description2: "Just a few final steps to complete",
};
